'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormContentRow = exports.StyledRow = undefined;
var _templateObject = _taggedTemplateLiteral(['\n  margin: ', ';\n  padding: ', ';\n  justify-content: ', ';\n  align-items: ', ';\n  width: 100%;\n  ', ';\n'], ['\n  margin: ', ';\n  padding: ', ';\n  justify-content: ', ';\n  align-items: ', ';\n  width: 100%;\n  ', ';\n']),
  _templateObject2 = _taggedTemplateLiteral(['', ''], ['', '']),
  _templateObject3 = _taggedTemplateLiteral(['\n  margin: 0 0 1rem 0;\n  padding-left: 0;\n  justify-content: flex-start;\n  width: 100%;\n  align-items: flex-end;\n'], ['\n  margin: 0 0 1rem 0;\n  padding-left: 0;\n  justify-content: flex-start;\n  width: 100%;\n  align-items: flex-end;\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _reactstrap = require('reactstrap');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var StyledRow = exports.StyledRow = (0, _styledComponents2.default)(_reactstrap.Row)(_templateObject, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.padding || 0;
}, function (props) {
  return props.justify || 'center';
}, function (props) {
  return props.align || 'center';
}, function (props) {
  return (0, _styledComponents.css)(_templateObject2, props.customstyle);
});
var FormContentRow = exports.FormContentRow = (0, _styledComponents2.default)(_reactstrap.Row)(_templateObject3);